import { gql } from '@apollo/client';

export const WORKPLACE_DOCTORS_QUERY = gql`
	query WorkplaceDoctors(
		$fulltext: String
		$workplaceId: UUID
		$workplaceIds: [UUID]
		$roleKeys: [String]
		$take: Int
	) {
		workplaceDoctors(
			fulltext: $fulltext
			workplaceId: $workplaceId
			workplaceIds: $workplaceIds
			roleKeys: $roleKeys
			pagination: { take: $take }
		) {
			data {
				__typename
				id
				user {
					id
					profile {
						id
						fullName
					}
				}
			}
		}
	}
`;
